// 固定顺序与后端 missingFields 一致；“无”是合法答案，不能当成缺项。
export const ADV_ASSET_FIELDS = Object.freeze(['house', 'vehicle', 'socialSecurity', 'providentFund'])

/** 冻结共享选项，避免补录页与修改页互相改变枚举或文案。 */
function freezeAssetOptions (options) {
  return Object.freeze(options.map(tempOption => Object.freeze(tempOption)))
}

const PAYMENT_PERIOD_OPTIONS = freezeAssetOptions([
  { label: '缴纳6个月以下', value: 1 },
  { label: '缴纳6-12个月', value: 2 },
  { label: '缴纳12个月以上', value: 3 },
  { label: '无', value: 4 }
])

export const ADV_ASSET_OPTIONS = Object.freeze({
  house: freezeAssetOptions([{ label: '有房', value: 1 }, { label: '无房', value: 2 }]),
  vehicle: freezeAssetOptions([{ label: '有车', value: 1 }, { label: '无车', value: 2 }]),
  socialSecurity: PAYMENT_PERIOD_OPTIONS,
  providentFund: PAYMENT_PERIOD_OPTIONS
})

// 与 advRouters 的实际页面注册复用同一契约，部署前缀由 Router base 管理。
export const ADV_ASSET_PAGE_ROUTE = Object.freeze({
  path: '/auth-adv/assetInfo',
  name: 'auth_adv_asset-info',
  meta: Object.freeze({ title: '完善资料' })
})

/** 白名单回显四项资产；兼容历史整数字符串，但不把布尔/小数/非法值变成已选答案。 */
export function normalizeAdvAssetInfo (assetInfo) {
  const tempAssetInfo = assetInfo && typeof assetInfo === 'object' && !Array.isArray(assetInfo) ? assetInfo : {}
  return ADV_ASSET_FIELDS.reduce((tempNormalized, tempField) => {
    const tempValue = tempAssetInfo[tempField]
    let tempNumber = tempValue
    if (typeof tempValue === 'string' && /^[+-]?\d+$/.test(tempValue.trim())) {
      tempNumber = Number(tempValue.trim())
    }
    const tempIsValid = typeof tempNumber === 'number' && Number.isInteger(tempNumber) &&
      ADV_ASSET_OPTIONS[tempField].some(tempOption => tempOption.value === tempNumber)
    tempNormalized[tempField] = tempIsValid ? tempNumber : ''
    return tempNormalized
  }, {})
}

/** 本地缺项只用于回显/表单校验；后续续办仍必须核验服务端 assetInfoComplete，不能单凭此列表自动申请。 */
export function getAdvAssetMissingFields (assetInfo) {
  const tempAssetInfo = normalizeAdvAssetInfo(assetInfo)
  return ADV_ASSET_FIELDS.filter(tempField => tempAssetInfo[tempField] === '')
}

/** query 仅控制展示，非法模式降级为修改；返回只允许授信页，不透传任何自动续办或身份参数。 */
export function normalizeAdvAssetPageQuery (query) {
  const tempQuery = query && typeof query === 'object' && !Array.isArray(query) ? query : {}
  return {
    mode: tempQuery.mode === 'supplement' ? 'supplement' : 'edit',
    returnName: 'borrow_adv_credit'
  }
}
